import axios from "axios";
import React, { useEffect, useState } from "react";
import { Table, Button, Form, Modal, Tabs, Tab } from "react-bootstrap";
import { FaEdit, FaEye, FaFileExcel, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

{/* Mapping field names to readable labels */ }
const fieldLabels = {
  name: "Student Name",
  email: "Student Email",
  phonenumber: "Phone Number",
  alternatenumber: "Alternate Number",
  address: "Student Address",
  city: "City",
  pincode: "Pincode",
  gender: "Gender",
  dob: "Date of Birth",
  yop: "Year of Passing",
  reference: "Reference",
  coursedetails: "Course Details",
  fees: "Fees",
  offerfees: "Offer Fees",
  joiningdate: "Joining Date",
  coursecompleted: "Course Completed",
  coursecompleteddate: "Course Completed Date",
  discontinued: "Discontinued",
  discontinueddate: "Discontinued Date",
  discontinuedreason: "Discontinued Reason",
  paymentmode: "Payment Mode",
  paymentamount: "NetCash Payment Amount",
  paymentdate: "NetCash Payment Date",
  emi: "EMI",
  level1amount: "EMI Level 1 Amount",
  level1date: "EMI Level 1 Date",
  level2amount: "EMI Level 2 Amount",
  level2date: " EMI Level 2 Date",
  level3amount: "EMI Level 3 Amount",
  level3date: "EMI Level 3 Date",
  paymentstatus: "Payment Status",
  paidamount: "Paid Amount",
  balanceamount: "Balance Amount",
  certificate: "Certificate",
  interviewpreparation: "Interview Preparation",
  interviewlevel: "Interview Level",
  mentorname: "Mentor Name",
  mentor1: "Mentor Name 1",
  mentor2: "Mentor Name2"
};


function Student({ onLogout }) {
  // const API_URL = "http://localhost:8000/student.php";

  const API_URL = "https://crm.fazoacademy.in/php/student.php";

  const navigate = useNavigate();

  const [student, setStudent] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null); // State to store selected student details
  const [courses, setCourses] = useState([]);
  const [mentor, setMentor] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  //search 
  // const [searchQuery, setSearchQuery] = useState("");
  const [searchType, setSearchType] = useState(""); // Store selected search type
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredStudents, setFilteredStudents] = useState([]);
  // const [filteredStudents, setFilteredStudents] = useState(student); // Initially all


  //date search
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");


  // Fetch student data
  const fetchStudent = async () => {
    try {
      const response = await axios.get(API_URL);
      console.log("Raw API Response:", response.data);

      // Extract only the JSON part (temporary fix)
      const jsonString = response.data.substring(response.data.indexOf("["));
      const parsedData = JSON.parse(jsonString);

      setStudent(Array.isArray(parsedData) ? parsedData : []);
    } catch (error) {
      console.error("Error fetching students:", error);
      setStudent([]);
    }
  };

  const fetchCourses = async () => {
    try {
      // const response = await axios.get(`http://localhost:8000/course.php`);
      const response = await axios.get(`https://crm.fazoacademy.in/php/course.php`);
      console.log("Raw API Response:", response.data);

      // Extract only the JSON part (temporary fix)
      const jsonString = response.data.substring(response.data.indexOf("["));
      const parsedData = JSON.parse(jsonString);

      setCourses(Array.isArray(parsedData) ? parsedData : []);
    } catch (error) {
      console.error("Error fetching courses:", error);
      setCourses([]);
    }
  };
  const fetchMentor = async () => {
    try {
      // const response = await axios.get(`http://localhost:8000/mentor.php`);
      const response = await axios.get(`https://crm.fazoacademy.in/php/mentor.php`);
      console.log("Raw API Response:", response.data);

      // Extract only the JSON part (temporary fix)
      const jsonString = response.data.substring(response.data.indexOf("["));
      const parsedData = JSON.parse(jsonString);

      setMentor(Array.isArray(parsedData) ? parsedData : []);
    } catch (error) {
      console.error("Error fetching courses:", error);
      setMentor([]);
    }
  };

  useEffect(() => {
    fetchCourses();
    fetchStudent();
    fetchMentor();
  }, []);

  // Delete student function
  const handleDeleteStudent = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.delete(`${API_URL}?id=${id}`);
          fetchStudent(); // Refresh data after deletion

          Swal.fire({
            icon: "success",
            title: "Deleted!",
            text: "Student has been deleted successfully.",
            showConfirmButton: false,
            timer: 2000,
          });
        } catch (error) {
          console.error("Error deleting student:", error);
          Swal.fire({
            icon: "error",
            title: "Oops!",
            text: "Failed to delete student. Please try again.",
          });
        }
      }
    });
  };

  useEffect(() => {
    // when 'student' is fetched
    setFilteredStudents(student);
  }, [student]);


  // Pagination Logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentStudents = filteredStudents.slice(indexOfFirstItem, indexOfLastItem);


  const handleEdit = (studentData) => {
      console.log("Editing student:", studentData); // 👈 Logs the data to the console
    navigate("/studentadd", { state: { studentData } });
  };

  // Function to open modal with selected student details
  const handleViewStudent = (student) => {
    setSelectedStudent(student);
    setShowModal(true);
  };



  const handleSearch = () => {
    if (!searchType || (!searchQuery.trim() && searchType !== "dob" &&
      searchType !== "joiningdate" && searchType !== "coursecompleteddate"
      && searchType !== "discontinueddate" && searchType !== "paymentdate")) {
      Swal.fire({
        icon: "warning",
        title: "Search Error",
        text: "Please select a search type and enter a query.",
      });
      return;
    }


    const filteredData = student.filter((item) => {
      if (
        searchType === "dob" ||
        searchType === "joiningdate" ||
        searchType === "coursecompleteddate" ||
        searchType === "discontinueddate" ||
        searchType === "paymentdate"
      ) {
        if (!fromDate || !toDate) {
          Swal.fire({
            icon: "warning",
            title: "Search Error",
            text: "Please select both FROM and TO dates.",
          });
          return false;
        }

        const dateField =
          searchType === "dob" ? item.dob :
            searchType === "joiningdate" ? item.joiningdate :
              searchType === "coursecompleteddate" ? item.coursecompleteddate :
                searchType === "discontinueddate" ? item.discontinueddate :
                  item.paymentdate; // Added discontinueddate and paymentdate

        return dateField >= fromDate && dateField <= toDate;
      }




      else if (searchType === "name") {
        return item.name.toLowerCase().includes(searchQuery.toLowerCase());
      } else if (searchType === "email") {
        return item.email.toLowerCase().includes(searchQuery.toLowerCase());
      } else if (searchType === "phone") {
        return item.phonenumber.includes(searchQuery);
      } else if (searchType === "city") {
        return item.city.toLowerCase().includes(searchQuery.toLowerCase());
      } else if (searchType === "yop") {
        return item.yop.includes(searchQuery);
      } else if (searchType === "gender") {
        return item.gender.toLowerCase() === searchQuery.toLowerCase();
      } else if (searchType === "coursedetails") {
        return item.coursedetails.toLowerCase() === searchQuery.toLowerCase();
      } else if (searchType === "mentor") {
        return item.mentorname.toLowerCase().includes(searchQuery.toLowerCase());
      } else if (searchType === "coursecompleted") {
        return item.coursecompleted.toLowerCase() === searchQuery.toLowerCase();
      } else if (searchType === "certificate") {
        return item.certificate.toLowerCase() === searchQuery.toLowerCase();
      } else if (searchType === "discontinued") {
        return item.discontinued.toLowerCase() === searchQuery.toLowerCase();
      } else if (searchType === "paymentstatus") {
        return item.paymentstatus.toLowerCase() === searchQuery.toLowerCase();
      } else if (searchType === "paymentmode") {
        return item.paymentmode?.toLowerCase() === searchQuery.toLowerCase();
      } else if (searchType === "interviewpreparation") {
        return item.interviewpreparation?.toLowerCase() === searchQuery.toLowerCase();
      }

      return false;
    });

    setFilteredStudents(filteredData);
  };


  const handleReset = () => {
    setFilteredStudents(student);  // Restore original list
    setSearchQuery("");
    setSearchType("");
    setFromDate("");
    setToDate("");
    setCurrentPage(1); // optional: reset to first page
  };

  const handleExportToExcel = () => {
    window.open(`${API_URL}?export=excel`, "_blank");
  };

  // const navigate = useNavigate();

  const handleAddClick = () => {
    navigate("/studentadd");
  };


  return (
    <>
      <div className="course-container">
        <div className="navigation">
          <a href="#">Student</a> / <a href="#" onClick={onLogout}>Logout</a>
        </div>

        <div className="add-course">
          <button className="add-btn" onClick={handleAddClick}>
            Add new Student +
          </button>
        </div>

        <Button onClick={handleExportToExcel} className="excel-btn">
          <FaFileExcel className="excel-icon" /> Export to Excel
        </Button>

        {/* Items per page selection */}


        <div className="row mb-3">
          <div className="col-md-2">
            <Form.Select
              value={itemsPerPage}
              onChange={(e) => setItemsPerPage(Number(e.target.value))}
              className="pagination-select"
            >
              <option value="10">Show 10</option>
              <option value="20">Show 20</option>
              <option value="30">Show 30</option>
            </Form.Select>
          </div>
          <div className="col-md-3">
            <select className="form-control" value={searchType} onChange={(e) => setSearchType(e.target.value)}>
              <option value="">Select Search Type</option>
              <option value="name">Name</option>
              <option value="email">Email</option>
              <option value="phone">Phone</option>
              <option value="city">City</option>
              <option value="yop">YOP</option>
              <option value="dob">Date of Birth</option>
              <option value="gender">Gender</option>
              <option value="coursedetails">Course Name</option>
              <option value="mentor">Mentor Name</option>
              <option value="coursecompleted">Course Completed</option>
              <option value="certificate">Certificate</option>
              <option value="discontinued">Discontinued</option>
              <option value="paymentstatus">Payment Status</option>
              <option value="paymentmode">Payment Method</option>
              <option value="interviewpreparation">Interview </option>
              <option value="joiningdate">Joining Date </option>
              <option value="coursecompleteddate"> Course Completed Date</option>
              <option value="discontinueddate"> Discontinued Date</option>
              <option value="paymentdate"> Payment Date</option>
            </select>
          </div>

          <div className="col-md-5">
            {searchType === "gender" ? (
              <select
                className="form-control"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              >
                <option value="">Select Gender</option>
                <option value="female">Female</option>
                <option value="male">Male</option>
              </select>
            ) :
              searchType === "coursedetails" ? (
                <select
                  className="form-control"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                >

                  <option value="" disabled>Select a course</option>
                  {courses.map((course, index) => (
                    <option key={index} value={course.name}>
                      {course.name}
                    </option>
                  ))}
                </select>
              ) :
                searchType === "mentor" ? (
                  <select
                    className="form-control"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  >
                    <option value="" disabled>Select a Mentor name</option>
                    {mentor.map((item, index) => (
                      <option key={index} value={item.name}>
                        {item.name}
                      </option>
                    ))}
                  </select>

                ) : searchType === "coursecompleted" ? (
                  <select
                    className="form-control"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  >
                    <option value="">Select </option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                ) :
                  searchType === "certificate" ? (
                    <select
                      className="form-control"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    >
                      <option value="">Select </option>
                      <option value="received">Received</option>
                      <option value="notrecived">Not Received</option>
                    </select>
                  ) :
                    searchType === "discontinued" ? (
                      <select
                        className="form-control"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                      >
                        <option value="">Select </option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                    ) :
                      searchType === "paymentstatus" ? (
                        <select
                          className="form-control"
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                        >
                          <option value="">Select </option>
                          <option value="paid">Paid</option>
                          <option value="not paid">Un Paid</option>
                        </select>
                      ) :

                        searchType === "paymentmode" ? (
                          <select
                            className="form-control"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                          >
                            <option value="">Select </option>
                            <option value="NetCash">Net Cash</option>
                            <option value="EMI">EMI</option>
                          </select>
                        ) :

                          searchType === "interviewpreparation" ? (
                            <select
                              className="form-control"
                              value={searchQuery}
                              onChange={(e) => setSearchQuery(e.target.value)}
                            >
                              <option value="">Select </option>
                              <option value="Start">Start</option>
                              <option value="Not Initiated">Not Initiated</option>
                            </select>
                          ) :

                            searchType === "dob" ? (
                              <div className="d-flex">
                                <input type="date" className="form-control me-2" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
                                <input type="date" className="form-control" value={toDate} onChange={(e) => setToDate(e.target.value)} />
                              </div>


                            ) :
                              searchType === "joiningdate" ? (
                                <div className="d-flex">
                                  <input type="date" className="form-control me-2" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
                                  <input type="date" className="form-control" value={toDate} onChange={(e) => setToDate(e.target.value)} />
                                </div>


                              )
                                :

                                searchType === "coursecompleteddate" ? (
                                  <div className="d-flex">
                                    <input type="date" className="form-control me-2" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
                                    <input type="date" className="form-control" value={toDate} onChange={(e) => setToDate(e.target.value)} />
                                  </div>


                                ) :
                                  searchType === "discontinueddate" ? (
                                    <div className="d-flex">
                                      <input type="date" className="form-control me-2" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
                                      <input type="date" className="form-control" value={toDate} onChange={(e) => setToDate(e.target.value)} />
                                    </div>


                                  ) : (
                                    searchType === "paymentdate" ? (
                                      <div className="d-flex">
                                        <input type="date" className="form-control me-2" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
                                        <input type="date" className="form-control" value={toDate} onChange={(e) => setToDate(e.target.value)} />
                                      </div>


                                    ) :
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search..."
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                      />
                                  )}
          </div>

          <div className="col-md-2">
            <button className="btn btn-primary" onClick={handleSearch}>Search</button>
            <button className="btn btn-secondary ms-2" onClick={handleReset}>Reset</button>
          </div>
        </div>


        <Table striped bordered hover className="course-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Student Name</th>
              <th>Email</th>
              <th>Phone Number</th>
              <th>Course Name</th>
              <th>Mentor Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentStudents.length === 0 ? (
              <tr>
                <td colSpan="7" className="text-center text-danger">
                  No details found
                </td>
              </tr>
            ) : (
              currentStudents.map((item, index) => (
                <tr key={item.id}
                  className={item.status === "Active" ? "table-success" : "table-danger"}>
                  <td>{indexOfFirstItem + index + 1}</td>
                  <td>{item.name}</td>
                  <td>{item.email}</td>
                  <td>{item.phonenumber}</td>
                  <td>{item.coursedetails}</td>
                  <td>
                    {item.mentor1}
                    {item.mentor1 && item.mentor2 && " - "}
                    {item.mentor2}
                  </td>

                  <td>
                    {item.status === "Active" ?
                      (<>
                        <FaEdit className="edit-icon" onClick={() => handleEdit(item)} /> &nbsp;
                        <FaTrash className="delete-icon" onClick={() => handleDeleteStudent(item.id)} /> &nbsp;
                        <FaEye className="view-icon" onClick={() => handleViewStudent(item)} />
                      </>) :
                      (
                        <FaEye className="view-icon" onClick={() => handleViewStudent(item)} />
                      )}

                  </td>
                </tr>
              ))
            )}
          </tbody>

        </Table>

        {/* Pagination Controls */}
        <div className="pagination-controls">
          <Button
            variant="secondary"
            onClick={() => setCurrentPage(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Previous
          </Button>
          <span className="page-number">Page {currentPage}</span>
          <Button
            variant="secondary"
            onClick={() => setCurrentPage(currentPage + 1)}
            disabled={indexOfLastItem >= filteredStudents.length}
          >
            Next
          </Button>
        </div>
      </div>


      {/* Modal for Viewing Student Details */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Student Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedStudent ? (
            <Tabs defaultActiveKey="general" id="student-details-tabs" className="mb-3">
              <Tab eventKey="general" title="General">
                <div className="d-flex w-100">


                  <div className="w-50">
                    <p><strong>{fieldLabels.name}:</strong> {selectedStudent.name}</p>
                    <p><strong>{fieldLabels.email}:</strong> {selectedStudent.email}</p>
                    <p><strong>{fieldLabels.phonenumber}:</strong> {selectedStudent.phonenumber}</p>
                    <p><strong>{fieldLabels.alternatenumber}:</strong> {selectedStudent.alternatenumber}</p>

                  </div>
                  <div className="w-50">
                    <p><strong>{fieldLabels.gender}:</strong> {selectedStudent.gender}</p>
                    <p><strong>{fieldLabels.dob}:</strong> {selectedStudent.dob}</p>
                    <p><strong>{fieldLabels.yop}:</strong> {selectedStudent.yop}</p>
                    <p><strong>{fieldLabels.mentor1}:</strong> {selectedStudent.mentor1}</p>
                    <p><strong>{fieldLabels.mentor2}:</strong> {selectedStudent.mentor2}</p>

                  </div>

                </div>

              </Tab>

              <Tab eventKey="address" title="Address">
                <p><strong>{fieldLabels.address}:</strong> {selectedStudent.address}</p>
                <p><strong>{fieldLabels.city}:</strong> {selectedStudent.city}</p>
                <p><strong>{fieldLabels.pincode}:</strong> {selectedStudent.pincode}</p>
              </Tab>
              <Tab eventKey="course" title="Course Details">
                <p><strong>{fieldLabels.coursedetails}:</strong> {selectedStudent.coursedetails}</p>
                <p><strong>{fieldLabels.fees}:</strong> {selectedStudent.fees}</p>
                <p><strong>{fieldLabels.offerfees}:</strong> {selectedStudent.offerfees}</p>
                <p><strong>{fieldLabels.reference}:</strong> {selectedStudent.reference}</p>
                <p><strong>{fieldLabels.joiningdate}:</strong> {selectedStudent.joiningdate}</p>

                {/* Show Course Completed details only if coursecompleted is "Yes" */}
                {selectedStudent.coursecompleted === "Yes" ? (
                  <>
                    <p><strong>{fieldLabels.coursecompleted}:</strong> {selectedStudent.coursecompleted}</p>
                    <p><strong>{fieldLabels.coursecompleteddate}:</strong> {selectedStudent.coursecompleteddate}</p>
                  </>
                ) :
                  // Show Discontinued details only if discontinued is "Yes"
                  selectedStudent.discontinued === "Yes" ? (
                    <>
                      <p><strong>{fieldLabels.discontinued}:</strong> {selectedStudent.discontinued}</p>
                      <p><strong>{fieldLabels.discontinueddate}:</strong> {selectedStudent.discontinueddate}</p>
                      <p><strong>{fieldLabels.discontinuedreason}:</strong> {selectedStudent.discontinuedreason}</p>
                    </>
                  ) : null}
              </Tab>

              <Tab eventKey="payment" title="Payment">
                <p><strong>{fieldLabels.paymentmode}:</strong> {selectedStudent.paymentmode}</p>

                {selectedStudent.paymentmode === "NetCash" ? (
                  <>
                    <p><strong>{fieldLabels.paymentamount}:</strong> {selectedStudent.paymentamount}</p>
                    <p><strong>{fieldLabels.paymentdate}:</strong> {selectedStudent.paymentdate}</p>
                  </>
                ) : (
                  <>
                    <p><strong>{fieldLabels.emi}:</strong> {selectedStudent.emi}</p>

                    {selectedStudent.emi === "level1" && (
                      <>
                        <p><strong>{fieldLabels.level1amount}:</strong> {selectedStudent.level1amount}</p>
                        <p><strong>{fieldLabels.level1date}:</strong> {selectedStudent.level1date}</p>
                      </>
                    )}

                    {selectedStudent.emi === "level2" && (
                      <>
                        <p><strong>{fieldLabels.level2amount}:</strong> {selectedStudent.level2amount}</p>
                        <p><strong>{fieldLabels.level2date}:</strong> {selectedStudent.level2date}</p>
                      </>
                    )}

                    {selectedStudent.emi === "level3" && (
                      <>
                        <p><strong>{fieldLabels.level3amount}:</strong> {selectedStudent.level3amount}</p>
                        <p><strong>{fieldLabels.level3date}:</strong> {selectedStudent.level3date}</p>
                      </>
                    )}
                  </>
                )}
              </Tab>

              <Tab eventKey="payment-status" title="Payment Status">
                <p><strong>{fieldLabels.paymentstatus}:</strong> {selectedStudent.paymentstatus}</p>
                {selectedStudent.paymentstatus === "Paid" && (
                  <>
                    <p><strong>{fieldLabels.paidamount}:</strong> {selectedStudent.paidamount}</p>

                  </>
                )}
                {selectedStudent.paymentstatus === "Not Paid" && (
                  <>
                    <p><strong>{fieldLabels.balanceamount}:</strong> {selectedStudent.balanceamount}</p>

                  </>
                )}

              </Tab>

              <Tab eventKey="interview" title="Interview Details">
                <p><strong>{fieldLabels.interviewpreparation}:</strong> {selectedStudent.interviewpreparation}</p>
                {selectedStudent.interviewpreparation === "Start" && (
                  <>
                    <p><strong>{fieldLabels.interviewlevel}:</strong> {selectedStudent.interviewlevel}</p>

                  </>
                )}
              </Tab>
            </Tabs>
          ) : (
            <p>No student selected.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>    </>
  );
}

export default Student;